import { render, staticRenderFns } from "./AnimalNumbers.vue?vue&type=template&id=42bd28f0&"
import script from "./AnimalNumbers.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports